import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import JsxHelper from '../Helpers/JsxHelper';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';

export default class FreelancerUserManagerItem {
  constructor(item) {
    if (item === undefined) {
      this.TpAdminId = '';
      this.ThirdPartyAdminId = '';
      this.ThirdPartyAdminName = '';
      this.ThirdPartyAdminEmail = '';
      this.ThirdPartyIsActive = '';
      this.ThirdPartySource = '';
      this.DepartmentLookupItemValue = null;
      this.DepartmentName = null;
      this.FreelancerUserManagerId = null;
      return;
    }
    this.TpAdminId = item.tpAdminId;
    this.ThirdPartyAdminId = item.thirdPartyAdminId;
    this.ThirdPartyAdminName = item.thirdPartyAdminName;
    this.ThirdPartyAdminEmail = item.thirdPartyAdminEmail;
    this.ThirdPartyIsActive = item.thirdPartyIsActive;
    this.ThirdPartySource = item.thirdPartySource;
    this.DepartmentLookupItemValue = item.departmentLookupItemValue;
    this.DepartmentName = item.departmentName;
    this.FreelancerUserManagerId = item.freelancerUserManagerId;
  }

  static NameOfTheIdField() {
    return 'FreelancerUserManagerId';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];
  static BoolFields = ['ThirdPartyIsActive'];

  static nameOfTheItemDetailList(item) {
    return `${item.ThirdPartyAdminId} - ${item.ThirdPartyAdminName}`;
  }

  static FieldsToShowInDataTable() {
    // prettier-ignore
    return [
      {
        label: 'Id',
        orderById: 'TpAdminId',
        data: 'TpAdminId',
        type: FieldTypesEnum.PureDataField,
        minWidth: 70,
      },
      {
        label: 'Third-Party Admin Id',
        orderById: 'ThirdPartyAdminId',
        data: 'ThirdPartyAdminId',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Name',
        orderById: 'ThirdPartyAdminName',
        data: 'ThirdPartyAdminName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Email',
        orderById: 'ThirdPartyAdminEmail',
        data: 'ThirdPartyAdminEmail',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Is Active',
        orderById: 'ThirdPartyIsActive',
        data: (item) => JsxHelper.YesNo(item.ThirdPartyIsActive),
        type: FieldTypesEnum.BoolFields,
      },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Department',
        orderById: 'DepartmentName',
        data: 'DepartmentName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: ' ',
        orderById: '',
        data: FreelancerUserManagerItem.getActionsCellContentItems,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getActionsCellContentItems(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-circle-minus',
            text: 'Remove Manager',
            onClick: () => FreelancerUserManagerItem.removeManagerFunction(item.FreelancerUserManagerId),
            roleKey: 'FreelancerUser_EditAction',
          },
        ]}
      />
    );
  }

  static removeManagerFunction = (id) => {
    alert('Empty function');
  };
}
